import { render, staticRenderFns } from "./screenModel.vue?vue&type=template&id=6ec94d82&scoped=true"
import script from "./screenModel.vue?vue&type=script&lang=js"
export * from "./screenModel.vue?vue&type=script&lang=js"
import style0 from "./screenModel.vue?vue&type=style&index=0&id=6ec94d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec94d82",
  null
  
)

export default component.exports